var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "./Base";
var AddBookmark = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 12 15" }),
        React.createElement("g", { id: "3.-View-results", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("g", { id: "View-results,-comments---bookmark-and-sentiment-analysis", transform: "translate(-1215.000000, -730.000000)", stroke: "#3D3D35", strokeWidth: "1.3" },
                React.createElement("g", { id: "Group-Copy-4", transform: "translate(1203.000000, 719.000000)" },
                    React.createElement("g", { id: "Bookmark", transform: "translate(13.000000, 11.000000)" },
                        React.createElement("polygon", { id: "Path", points: "0.18 0.97 10.33 0.97 10.33 13.99 5.18 9.5 0.19 14.14" })))))));
};
export default AddBookmark;
